import React, { useState, useContext, useEffect } from "react";
import { useField, useForm } from "react-final-form";
import { IntlContext, ListContext } from "context";
import { resetQueryString } from "helpers/url";
import { TextField } from "components/Form/Field";

export type DisplayMode = "filters" | null;

interface Props {
    changeMode: (mode: DisplayMode) => void;
    value?: (value: any) => void;
}

const MainSearch: React.FC<Props> = ({ changeMode, value }) => {
    const intl = useContext(IntlContext);
    const { setSelectedItems, setActiveFetch } = useContext(ListContext);
    const form = useForm();
    const [show, setShow] = useState<DisplayMode>(null);
    const fnameValue = useField("filter_name").input.value;
    const secteurValue = useField("filter_secteur").input.value;
    const familleValue = useField("filter_famille").input.value;

    useEffect(() => {
        if (value) {
            value(fnameValue);
        }
    }, [fnameValue, value]);

    const toggleMode = (mode: DisplayMode) => {
        const newMode = show !== mode ? mode : null;
        setShow(newMode);
        changeMode(newMode);
    };

    const resetForm = () => {
        setSelectedItems([]);
        form.reset({});
    };

    const btnKeyPress = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        e.preventDefault();
    };

    const submitSearch = (e: React.FormEvent<HTMLButtonElement>) => {
        if (!canSearch()) {
            e.preventDefault();
            return false;
        }
        setActiveFetch(true);
        resetQueryString();
        form.submit();
    };

    const canSearch = () => {
        return Boolean(fnameValue?.trim()?.length || secteurValue?.length || familleValue?.length);
    }

    return (
        <React.Fragment>
            <div className="search-bar">
                <TextField
                    inputProps={{
                        name: "filter_name",
                        type: "search",
                        id: "search-bar-input",
                        className: "search-bar__input",
                        placeholder: intl.formatMessage("produit.placeholder.search"),
                    }}
                />

                <button
                    className="search-bar__button cta cta--primary"
                    title={intl.formatMessage("generic.search")}
                    onClick={submitSearch}
                >
                    <i className="icon icon-search"></i> {intl.formatMessage("generic.search")}
                </button>
            </div>

            <div className="search-actions">
                {Boolean(canSearch() || show === "filters") && (
                    <button
                        type="button"
                        className="cta cta--link filter-reset"
                        onClick={() => {
                            toggleMode(null);
                            resetQueryString();
                            resetForm();
                            setActiveFetch(false);
                        }}
                        onKeyPress={btnKeyPress}
                    >
                        <i className="icon icon-cross"></i> {intl.formatMessage("generic.reset")}
                    </button>
                )}

                {show !== "filters" && (
                    <button
                        type="button"
                        className="cta cta--link filter-open"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            toggleMode("filters");
                        }}
                        onKeyPress={btnKeyPress}
                    >
                        <i className="icon icon-filter"></i> {intl.formatMessage("generic.filter")}
                    </button>
                )}
            </div>
        </React.Fragment>
    );
};

export default MainSearch;
